import type { IApiErrorResponse } from '../../../helpers/api/models';

import type { TRetryView, TChange, TGetState } from './models';

const getStatus = (isRetry: boolean | undefined, currentError: string, change: TChange) => {
    if (isRetry) {
        change('isRetryRequest', false);
        change('errorStatus', 'technicalError');

        return;
    }
    change('isRetryRequest', true);
    change('errorStatus', currentError);
};

export const handleError = (
    error: IApiErrorResponse,
    change: TChange,
    getState: TGetState,
    retryViews: TRetryView,
    retryStatusMessages: string[]
) => {
    const { isRetryRequest } = getState().values;
    const { data } = error;

    change('authenticationStatus', 'error');

    if (retryStatusMessages.includes(data.status)) {
        const currentError = retryViews[data.status];

        return getStatus(isRetryRequest, currentError, change);
    }

    throw Object.assign(new Error(''), { ...error });
};
